import classNames from 'classnames';

import useStyles from './styles';
import { ISingleToolLogo } from './types';

function SingleToolLogo({ className, href }: ISingleToolLogo) {
  const classes = useStyles();

  return (
    <a href={href} className={classNames(classes.root, className)}>
      <img
        className={classes.logo}
        src="https://cdn140.picsart.com/quicktools-logo.svg"
        alt="Quicktools by Picsart"
        width="175"
        height="59"
      />
    </a>
  );
}

export default SingleToolLogo;
